import React, { useMemo, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  exportInvoicePdf,
  getInvoiceHeader,
} from "../../../actions/invoiceAction";

import { setSelectedInvoicesToRedux } from "../../../actions/paymentAction";
import "../Dashboard.css";

const PAGE_SIZE = 10;

export default function InvoiceTab(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const invoiceInfo = useSelector((state) => state?.getInvoiceHeader);
  const myAccountInfo = useSelector((state) => state.getMyAccount);

  const { loading, error, invoiceHeader } = invoiceInfo;
  const { loadingMyAccount, errorMyAccount, myAccount } = myAccountInfo;

  console.log("invoiceHeader:", invoiceHeader);
  console.log("myAccount:", myAccount);

  //validate user
  const { search } = useLocation(); //search is gonna be "/Home"
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/Login"; // check if redirect url exist

  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo, userLoading, userError } = userSignin;

  // payment permission
  const paymentPermission = userInfo.result.user.permissions.Payment;

  // for multi payment
  // const [selectedInvoices, setSelectedInvoices] = useState([]);

  // Pagination--------------------------------
  const [page, setPage] = useState(1);

  const totalItems = invoiceHeader?.length ?? 0;
  const totalPages = Math.max(1, Math.ceil(totalItems / PAGE_SIZE));
  const safePage = Math.min(page, totalPages);
  const pageStart = (safePage - 1) * PAGE_SIZE;

  // slice invoiceHeader object list by PAGE_SIZE
  const visibleRows = useMemo(() => {
    const start = pageStart;
    return (invoiceHeader ?? []).slice(start, start + PAGE_SIZE);
  }, [invoiceHeader, pageStart]);

  // page move button
  const goToPage = (n) => setPage(Math.min(Math.max(1, n), totalPages));
  const prev = () => goToPage(safePage - 1);
  const next = () => goToPage(safePage + 1);

  // calculate the number pages of table
  const startIndex = totalItems === 0 ? 0 : pageStart + 1;
  const endIndex = Math.min(safePage * PAGE_SIZE, totalItems);
  const showingCount = totalItems === 0 ? 0 : endIndex - startIndex + 1;

  // keep 5 buttons window
  const getWindowPages = (current, total, size = 5) => {
    if (total <= size) return Array.from({ length: total }, (_, i) => i + 1);
    const half = Math.floor(size / 2); // 2
    let start = current - half;
    let end = current + half;
    if (start < 1) {
      start = 1;
      end = size;
    }
    if (end > total) {
      end = total;
      start = total - size + 1;
    }
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  // Initialize the selected checkbox when invoice table page is changed
  /* useEffect(() => {
    // Clear the checkboxes
    setSelectedIds(new Set());

    // Reset indeterminate/checked of header checkbox
    if (headerCbRef.current) {
      headerCbRef.current.indeterminate = false;
    }
  }, [safePage]); */

  // checkbox ---------------------------------------
  const [selectedIds, setSelectedIds] = useState(new Set());

  // ids of currently rendered rows (page)
  const visibleIds = useMemo(
    () => (visibleRows || []).map((inv) => inv.erpInvoiceId),
    [visibleRows]
  );

  // selected invoices
  const selectedInvoices = useMemo(
    () =>
      (invoiceHeader || []).filter((inv) => selectedIds.has(inv.erpInvoiceId)),
    [invoiceHeader, selectedIds]
  );

  // select a checkbox
  const toggleRow = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  // select all visible checkboxes
  const allChecked =
    visibleIds.length > 0 && visibleIds.every((id) => selectedIds.has(id));
  const someChecked = visibleIds.some((id) => selectedIds.has(id));

  const toggleAllVisible = () => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      const alreadyAll = visibleIds.every((id) => next.has(id));
      if (alreadyAll) visibleIds.forEach((id) => next.delete(id));
      else visibleIds.forEach((id) => next.add(id));
      return next;
    });
  };

  // parse number format safely
  const toNumber = (v) =>
    typeof v === "number" ? v : Number(String(v).replace(/[^0-9.-]/g, "")) || 0;

  // sum of balanceDue for selected rows (across all data)
  const selectedTotal = useMemo(
    () =>
      (invoiceHeader || [])
        .filter((inv) => selectedIds.has(inv.erpInvoiceId))
        .reduce((sum, inv) => sum + toNumber(inv.balanceDue), 0),
    [invoiceHeader, selectedIds]
  );

  const fmt = (n) =>
    `$${n.toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

  // make the header checkbox show "indeterminate" when some (not all) visible rows are checked
  const headerCbRef = useRef(null);
  useEffect(() => {
    if (headerCbRef.current) {
      headerCbRef.current.indeterminate = someChecked && !allChecked;
    }
  }, [someChecked, allChecked]);

  // pay invoice button -------------------------------

  // set selectedInvoices in the store
  const handlePayInvoice = () => {
    if (selectedInvoices.length === 0) {
      alert("Please select the invoice you want to pay.");
      return;
    }

    console.log("selectedInvoices in handlePayInvoice:", selectedInvoices);

    // store selected invoices to redux
    dispatch(setSelectedInvoicesToRedux(selectedInvoices));

    // Navigate to PaymentTab
    navigate("/myaccount#creditPayment");
  };

  useEffect(() => {
    if (!userInfo) {
      alert("Please sign in to access our website. ");

      // Remove IRG token
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");

      navigate(redirect);
    } else {
      console.log("You are already logged in ");
      console.log("userId : ", userInfo.result.user.userId);
    }

    console.log("userId : ", userInfo.result.user.userId);

    dispatch(getInvoiceHeader(userInfo.result.user.userId));
    console.log("invoiceHeader in useEffect: ", invoiceHeader);
  }, [dispatch, navigate, redirect, userInfo]);

  if (loading) {
    return <div>Loading...</div>;
  }

  // if (
  //   invoiceHeader === undefined ||
  //   invoiceHeader === null ||
  //   invoiceHeader.length === 0
  // ) {
  //   return <div>You invoice history is empty.</div>;
  // }

  // date format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  // compare the current system time for invoice
  const isPastDue = (dueDateString) => {
    const currentDate = new Date();
    const dueDate = new Date(dueDateString);
    return currentDate > dueDate;
  };

  // view invoice
  const viewInvoice = (erpInvoiceId, invoiceNum) => {
    // for moving dashboard tab (update parent component's state)
    props.setSelectedErpInvoiceId(erpInvoiceId);
    props.setSelectedInvoiceNum(invoiceNum);
  };

  const handleClickDownloadInvoice = (erpInvoiceId, invoiceNum) => {
    dispatch(exportInvoicePdf(erpInvoiceId, invoiceNum));
  };

  return (
    <>
      <div
        className="w-full bg-[#F8F9FA] mb-10px"
        style={{
          borderTop: "1px solid var(--Main-Stroke, #C3C3C3)",
        }}
      >
        {/* Invoice Title */}
        <div className="invoice-title">View/Pay Invoice</div>
        {/* Invoice summary card */}
        <div className="invoice-summary-wrapper">
          <div className="invoice-summary-card">
            {/*  Total Amount Section */}
            <div className="total-amount-wrapper">
              <div className="total-amount-content">
                <span className="total-amount-text">Total Amount to Pay</span>
              </div>
            </div>
            <div className="total-amount-value">
              $
              {Math.abs(
                myAccount?.result?.result?.accounting?.totalAmount ?? 0
              ).toFixed(2)}
            </div>

            {/* Blue box */}
            <div className="summary-info-container">
              <div className="summary-info-inner">
                {/* Past Due Amount Section */}
                <div className="past-due-column">
                  <span className="past-due-label">Past Due Amount</span>
                  <span className="past-due-value">
                    {" "}
                    $
                    {Math.abs(
                      myAccount?.result?.result?.accounting?.pastDueAmount ?? 0
                    ).toFixed(2)}
                  </span>

                  {/* Warning Message Row */}
                  <div className="warning-row">
                    {/* SVG Icon */}
                    <div className="warning-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.7857 12.4123L8.92995 1.02213C8.78362 0.743078 8.57472 0.5117 8.32396 0.350933C8.07319 0.190166 7.78927 0.105591 7.50033 0.105591C7.2114 0.105591 6.92747 0.190166 6.67671 0.350933C6.42595 0.5117 6.21705 0.743078 6.07072 1.02213L0.214993 12.4123C0.0741985 12.6822 0 12.9892 0 13.3018C0 13.6144 0.0741985 13.9213 0.214993 14.1913C0.359448 14.472 0.567991 14.7046 0.819222 14.8653C1.07045 15.026 1.35533 15.1089 1.64461 15.1055H13.3561C13.6451 15.1086 13.9297 15.0256 14.1807 14.8649C14.4317 14.7043 14.64 14.4718 14.7843 14.1913C14.9253 13.9215 14.9998 13.6146 15 13.302C15.0002 12.9894 14.9263 12.6823 14.7857 12.4123ZM6.96465 6.10558C6.96465 5.94645 7.02109 5.79384 7.12155 5.68132C7.22201 5.5688 7.35826 5.50559 7.50033 5.50559C7.64241 5.50559 7.77866 5.5688 7.87912 5.68132C7.97958 5.79384 8.03602 5.94645 8.03602 6.10558V9.10555C8.03602 9.26468 7.97958 9.41729 7.87912 9.52981C7.77866 9.64233 7.64241 9.70555 7.50033 9.70555C7.35826 9.70555 7.22201 9.64233 7.12155 9.52981C7.02109 9.41729 6.96465 9.26468 6.96465 9.10555V6.10558ZM7.50033 12.7055C7.34141 12.7055 7.18606 12.6527 7.05392 12.5538C6.92178 12.4549 6.81879 12.3144 6.75797 12.1499C6.69715 11.9855 6.68124 11.8045 6.71224 11.6299C6.74325 11.4554 6.81978 11.295 6.93215 11.1691C7.04453 11.0433 7.1877 10.9576 7.34357 10.9228C7.49944 10.8881 7.66101 10.9059 7.80783 10.974C7.95466 11.0422 8.08015 11.1575 8.16844 11.3055C8.25674 11.4535 8.30386 11.6275 8.30386 11.8055C8.30386 12.0442 8.21921 12.2731 8.06852 12.4419C7.91782 12.6107 7.71344 12.7055 7.50033 12.7055Z"
                          fill="#FF4444"
                        />
                      </svg>
                    </div>

                    {/* Warning message text */}
                    <div className="warning-text">
                      You have one or more overdue invoices.
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </div>  
        </div>

        <div className="invoice-payment-note">
          <strong>Note:</strong> Payments are processed after submission.
          <br />
          Please allow up to one business day for the payment to be applied to your invoice.
        </div>
          
        <div className="invoice-table-wrapper"> 
          <div className="invoice-table-header"> 
            {/* Pay invoice button */}
            {paymentPermission === 1 && (
              <button className="pay-invoice-button" onClick={handlePayInvoice}>
                Pay Invoice
              </button>
            )}
            {/* If anything selected, show total; otherwise show the message */}
            {selectedIds.size > 0 ? (
              <span className="no-invoice-text">{`Selected Payment Amount: ${fmt(
                selectedTotal
              )}`}</span>
            ) : (
              <span className="no-invoice-text">No invoices Selected</span>
            )}
          </div>
          {/* Invoice table*/}
          <table className="invoice-table">
            <thead>
              <tr className="invoice-table-header-row">
                {/* Check box */}
                <th>
                  <label className="cb">
                    <input
                      ref={headerCbRef}
                      type="checkbox"
                      checked={allChecked}
                      onChange={toggleAllVisible}
                    />
                    <span className="cb-svg" aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        {/* Border line of checkbox before choosing */}
                        <path
                          d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM4.16667 15.8333H15.8333V4.16667H4.16667V15.8333Z"
                          fill="#7C7C7C"
                        />
                        {/* Checkbox of checkbox */}
                        <rect
                          className="fill"
                          x="3.2"
                          y="3.2"
                          width="13.6"
                          height="13.6"
                          rx="0"
                          fill="transparent"
                        />
                        {/* Thick of checkbox  */}
                        <path
                          className="tick"
                          d="M8.83333 13.5L14.7083 7.625L13.5417 6.45833L8.83333 11.1667L6.45833 8.79167L5.29167 9.95833L8.83333 13.5Z"
                          fill="white"
                          opacity="0"
                        />
                      </svg>
                    </span>
                  </label>
                </th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      width: "52px",
                      height: "34px",
                      paddingRight: "1px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    Invoice Number
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      width: "60px",
                      height: "34px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                      marginRight: "30px",
                    }}
                  >
                    Invoice Date
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      width: "65px",
                      height: "34px",
                      paddingRight: "1px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    Po Number
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      width: "50px",
                      height: "34px",
                      paddingRight: "1px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    Invoice Amount
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      width: "50px",
                      height: "34px",
                      paddingRight: "1px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    Amount Paid
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      width: "50px",
                      height: "34px",
                      paddingRight: "1px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    Balance Due
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      width: "60px",
                      height: "34px",
                      padding: "8px 0 9px 0",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                      marginRight: "15px",
                    }}
                  >
                    Due Date
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      width: "40px",
                      height: "17px",
                      paddingRight: "1px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    Status
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      width: "75px",
                      height: "17px",
                      paddingRight: "1px",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    View / Save
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Loading/empty handled here (no early return above) */}
              {loading && (
                <tr>
                  <td colSpan={11} style={{ padding: 12, color: "#474747" }}>
                    Loading…
                  </td>
                </tr>
              )}

              {!loading && visibleRows.length === 0 && (
                <tr>
                  <td colSpan={11} style={{ padding: 12, color: "#474747" }}>
                    Your invoice history is empty
                  </td>
                </tr>
              )}

              {!loading &&
                visibleRows.map((invoice, idx) => {
                  const globalIndex = pageStart + idx; // keep zebra striping across pages
                  return (
                    <tr
                      key={invoice.erpInvoiceId}
                      className={
                        globalIndex % 2 === 0
                          ? "invoice-row-white"
                          : "invoice-row-grey"
                      }
                    >
                      <td className="invoice-row-wrapper">
                        {/* Check box */}
                        <label className="cb">
                          <input
                            type="checkbox"
                            checked={selectedIds.has(invoice.erpInvoiceId)}
                            onChange={() => toggleRow(invoice.erpInvoiceId)}
                          />
                          <span className="cb-svg" aria-hidden="true">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM4.16667 15.8333H15.8333V4.16667H4.16667V15.8333Z"
                                fill="#7C7C7C"
                              />

                              <rect
                                className="fill"
                                x="3.2"
                                y="3.2"
                                width="13.6"
                                height="13.6"
                                rx="0"
                                fill="transparent"
                              />

                              <path
                                className="tick"
                                d="M8.83333 13.5L14.7083 7.625L13.5417 6.45833L8.83333 11.1667L6.45833 8.79167L5.29167 9.95833L8.83333 13.5Z"
                                fill="white"
                                opacity="0"
                              />
                            </svg>
                          </span>
                        </label>
                      </td>
                      <td className="invoice-row-wrapper">
                        {/* Invoice# */}
                        <div className="invoice-row-cell">
                          <span
                            style={{
                              fontWeight: 700,
                              color: isPastDue(invoice.dueDate)
                                ? "#F44"
                                : "#474747",
                            }}
                          >
                            {invoice.num}
                          </span>
                        </div>
                      </td>
                      {/* Invoice date */}
                      <td className="invoice-row-wrapper">
                        <div className="invoice-row-cell">
                          <span
                            style={{
                              color: isPastDue(invoice.dueDate)
                                ? "#F44"
                                : "#474747",
                            }}
                          >
                            {formatDate(invoice.invoiceDate)}
                          </span>
                        </div>
                      </td>
                      {/* PO# */}
                      <td className="invoice-row-wrapper">
                        <div className="invoice-row-cell">
                          <span
                            style={{
                              color: isPastDue(invoice.dueDate)
                                ? "#F44"
                                : "#474747",
                            }}
                          >
                            {invoice.customerPo}
                          </span>
                        </div>
                      </td>
                      {/* Total Amount */}
                      <td className="invoice-row-wrapper">
                        <div className="invoice-row-cell">
                          <span
                            style={{
                              color: isPastDue(invoice.dueDate)
                                ? "#F44"
                                : "#474747",
                            }}
                          >
                            ${invoice.totalAmount}
                          </span>
                        </div>
                      </td>
                      {/* Amount Paid */}
                      <td className="invoice-row-wrapper">
                        <div className="invoice-row-cell">
                          <span
                            style={{
                              color: isPastDue(invoice.dueDate)
                                ? "#F44"
                                : "#474747",
                            }}
                          >
                            ${invoice.totalAmount - invoice.balanceDue}
                          </span>
                        </div>
                      </td>
                      {/* Balance Due */}
                      <td className="invoice-row-wrapper">
                        <div className="invoice-row-cell">
                          <span
                            style={{
                              color: isPastDue(invoice.dueDate)
                                ? "#F44"
                                : "#474747",
                            }}
                          >
                            ${invoice.balanceDue}
                          </span>
                        </div>
                      </td>
                      {/* Due Date */}
                      <td className="invoice-row-wrapper">
                        <div className="invoice-row-cell">
                          <span
                            style={{
                              color: isPastDue(invoice.dueDate)
                                ? "#F44"
                                : "#474747",
                            }}
                          >
                            {formatDate(invoice.dueDate)}
                          </span>
                        </div>
                      </td>
                      {/* Status */}
                      <td className="invoice-row-wrapper">
                        <div className="invoice-row-cell">
                          {(() => {
                            const pastDue = isPastDue(invoice.dueDate); // your helper
                            const label = pastDue ? "PastDue" : "Current";
                            const cls = pastDue
                              ? "status-badge pastdue"
                              : "status-badge current";
                            return (
                              <span
                                className={cls}
                                aria-label={`Invoice status: ${label}`}
                              >
                                {label}
                              </span>
                            );
                          })()}
                        </div>
                      </td>
                      {/* View/Save */}
                      <td className="invoice-row-wrapper">
                        <div className="invoice-row-cell">
                          <Link
                            onClick={() =>
                              viewInvoice(invoice.erpInvoiceId, invoice.num)
                            }
                            to="/myaccount#viewInvoice"
                            style={{
                              width: "20px",
                              height: "15px",
                              flexShrink: 0,
                              marginRight: "10px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="15"
                              viewBox="0 0 20 15"
                              fill="none"
                            >
                              <path
                                d="M0.716757 8.21957C0.594405 8.21957 0.46924 8.1885 0.356733 8.12071C0.0149911 7.92016 -0.100329 7.47952 0.0979654 7.13634C0.7041 6.09265 2.00919 4.0999 3.94854 2.46869C5.89351 0.83043 7.9299 0 9.99863 0C10.3952 0 10.7159 0.322004 10.7159 0.720271C10.7159 1.11854 10.3952 1.44054 9.99863 1.44054C6.36183 1.44054 3.13989 4.75803 1.33696 7.86226C1.20335 8.09105 0.962868 8.21957 0.716757 8.21957Z"
                                fill="#A6A5A3"
                              />
                              <path
                                d="M9.99859 14.9987C7.92986 14.9987 5.89347 14.1683 3.94709 12.53C2.00915 10.8988 0.702653 8.90465 0.0979243 7.86237C-0.101777 7.51918 0.0135436 7.07714 0.356692 6.878C0.698434 6.67746 1.13721 6.79326 1.33691 7.13786C3.13985 10.2421 6.36319 13.5596 9.99859 13.5596C10.3952 13.5596 10.7158 13.8816 10.7158 14.2799C10.7158 14.6781 10.3952 15.0001 9.99859 15.0001V14.9987Z"
                                fill="#A6A5A3"
                              />
                              <path
                                d="M9.99849 14.9987C9.6019 14.9987 9.28125 14.6767 9.28125 14.2784C9.28125 13.8802 9.6019 13.5582 9.99849 13.5582C13.6353 13.5582 16.8572 10.2407 18.6602 7.13645C18.8599 6.79327 19.2986 6.67605 19.6404 6.87659C19.9821 7.07714 20.0974 7.51777 19.8992 7.86096C19.293 8.90465 17.9879 10.8974 16.0486 12.5286C14.1022 14.1669 12.0672 14.9973 9.99708 14.9973L9.99849 14.9987Z"
                                fill="#A6A5A3"
                              />
                              <path
                                d="M19.2823 8.21957C19.0362 8.21957 18.7957 8.09105 18.6621 7.86226C16.8592 4.75803 13.6358 1.44054 10.0004 1.44054C9.60385 1.44054 9.2832 1.11854 9.2832 0.720271C9.2832 0.322004 9.60385 0 10.0004 0C12.0692 0 14.1056 0.83043 16.0519 2.46869C17.9913 4.0999 19.2964 6.09406 19.9025 7.13634C20.1022 7.47952 19.9869 7.92157 19.6437 8.12071C19.5298 8.18709 19.4061 8.21957 19.2837 8.21957H19.2823Z"
                                fill="#A6A5A3"
                              />
                              <path
                                d="M9.99874 12.0329C7.50951 12.0329 5.48438 9.99918 5.48438 7.49942C5.48438 4.99965 7.50951 2.96594 9.99874 2.96594C12.488 2.96594 14.5131 4.99965 14.5131 7.49942C14.5131 9.99918 12.488 12.0329 9.99874 12.0329ZM9.99874 4.40649C8.29988 4.40649 6.91885 5.79336 6.91885 7.49942C6.91885 9.20547 8.29988 10.5923 9.99874 10.5923C11.6976 10.5923 13.0786 9.20547 13.0786 7.49942C13.0786 5.79336 11.6976 4.40649 9.99874 4.40649Z"
                                fill="#A6A5A3"
                              />
                            </svg>
                          </Link>
                          <div
                            onClick={() =>
                              handleClickDownloadInvoice(
                                invoice.erpInvoiceId,
                                invoice.num
                              )
                            }
                            className="text-center"
                            style={{
                              width: "18px",
                              height: "18px",
                              flexShrink: 0,
                              cursor: "pointer",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                            >
                              <path
                                d="M16 9V16H2V9H0V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V9H16ZM10 9.67L12.59 7.09L14 8.5L9 13.5L4 8.5L5.41 7.09L8 9.67V0H10V9.67Z"
                                fill="#A6A5A3"
                              />
                            </svg>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          {/* Pagination footer */}
          <div className="pager">
            {/* message */}
            <div className="pager__message">
              {`Page ${safePage} - Showing ${showingCount} item${
                showingCount === 1 ? "" : "s"
              }`}
            </div>

            {/* buttons container */}
            <div className="pager__wrap" aria-label="Pagination">
              {/* prev */}
              <button
                type="button"
                onClick={prev}
                disabled={safePage === 1}
                className={`pager__arrow ${safePage === 1 ? "is-edge" : ""}`}
                aria-label="Previous page"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <path
                    d="M5.04384 7.16063L10.2685 2.1825C10.3557 2.0994 10.4715 2.05304 10.592 2.05304C10.7124 2.05304 10.8282 2.0994 10.9154 2.1825L10.921 2.18813C10.9634 2.22842 10.9972 2.27691 11.0203 2.33066C11.0434 2.38441 11.0553 2.44229 11.0553 2.50078C11.0553 2.55928 11.0434 2.61716 11.0203 2.67091C10.9972 2.72466 10.9634 2.77315 10.921 2.81344L6.00103 7.50094L10.921 12.1866C10.9634 12.2269 10.9972 12.2753 11.0203 12.3291C11.0434 12.3828 11.0553 12.4407 11.0553 12.4992C11.0553 12.5577 11.0434 12.6156 11.0203 12.6693C10.9972 12.7231 10.9634 12.7716 10.921 12.8119L10.9154 12.8175C10.8282 12.9006 10.7124 12.947 10.592 12.947C10.4715 12.947 10.3557 12.9006 10.2685 12.8175L5.04384 7.83938C4.9979 7.7956 4.96131 7.74295 4.93632 7.68461C4.91133 7.62627 4.89844 7.56347 4.89844 7.5C4.89844 7.43654 4.91133 7.37373 4.93632 7.3154C4.96131 7.25706 4.9979 7.20441 5.04384 7.16063Z"
                    fill="#0B0B0B"
                  />
                </svg>
              </button>

              {/* 5 buttons */}
              {getWindowPages(safePage, totalPages, 5).map((p) => (
                <button
                  key={p}
                  type="button"
                  onClick={() => goToPage(p)}
                  className={
                    p === safePage ? "pager__btn--selected" : "pager__btn"
                  }
                  aria-current={p === safePage ? "page" : undefined}
                >
                  {p}
                </button>
              ))}

              {/* next */}
              <button
                type="button"
                onClick={next}
                disabled={safePage === totalPages}
                className={`pager__arrow ${
                  safePage === totalPages ? "is-edge" : ""
                }`}
                aria-label="Next page"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <path
                    d="M9.95616 7.16063L4.73147 2.1825C4.64429 2.0994 4.52847 2.05304 4.40803 2.05304C4.28759 2.05304 4.17177 2.0994 4.08459 2.1825L4.07897 2.18813C4.03656 2.22842 4.00279 2.27691 3.97972 2.33066C3.95664 2.38441 3.94474 2.44229 3.94474 2.50078C3.94474 2.55928 3.95664 2.61716 3.97972 2.67091C4.00279 2.72466 4.03656 2.77315 4.07897 2.81344L8.99897 7.50094L4.07897 12.1866C4.03656 12.2269 4.00279 12.2753 3.97972 12.3291C3.95664 12.3828 3.94474 12.4407 3.94474 12.4992C3.94474 12.5577 3.95664 12.6156 3.97972 12.6693C4.00279 12.7231 4.03656 12.7716 4.07897 12.8119L4.08459 12.8175C4.17177 12.9006 4.28759 12.947 4.40803 12.947C4.52847 12.947 4.64429 12.9006 4.73147 12.8175L9.95616 7.83938C10.0021 7.7956 10.0387 7.74295 10.0637 7.68461C10.0887 7.62627 10.1016 7.56347 10.1016 7.5C10.1016 7.43654 10.0887 7.37373 10.0637 7.3154C10.0387 7.25706 10.0021 7.20441 9.95616 7.16063Z"
                    fill="#0B0B0B"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
